import { Pipe, PipeTransform } from '@angular/core';
import { ColumnDefinition } from 'src/app/models/server/column-definition';
import { History } from 'src/app/models/server/history';

@Pipe({
    name: 'avmHistoryCellPipe',
    standalone: true,
    pure: true,
})
export class AvmHistoryCellPipe implements PipeTransform {
    constructor() {}

    /**
     * Formate une cellule de la liste des entrées d'historique.
     * @param history : Instance du document affiché par la ligne contenant la cellule.
     * @param columnDefinition : Définition de la colonne affichant la cellule
     */
    transform(history: History, columnDefinition: ColumnDefinition): string {
        //console.count(`AvmHistoryCellPipe - transform ${history.id} - ${columnDefinition.header}`);

        if (!!history[columnDefinition.propertyCode]) {
            return `${history[columnDefinition.propertyCode]}`;
        } else {
            return '';
        }
    }
}
